import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@environments/environment';

@Component({
    selector: 'lib-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styles: [],
    standalone: false
})
export class ConfirmationDialog implements OnInit {
  public isMobile: boolean;
  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    this.isMobile = environment.platform === 'mobile';
  }

  ngOnInit(): void {}
}
